<template lang="pug">
modal#invitation-error-modal(
  :removeCloseButton='true'
  :show-cancel-button='false'
  :title='$t("modal.invitationError.title")'
  @closed='onCloseModal'
  @process='goToDashboard'
  process-button-label='$t("button.ok")'
  ref='modal'
  size='md'
)
  .inner-content
    .text-center.my-4
      img.img-fluid(src='/img/ilustrations/organizations-hierarchy.svg')
    p.justify-content {{ $t('modal.invitationError.message') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'InvitationErrorModal',
  components: {
    Modal,
  },
  data() {
    return {
      confirmOk: false,
    };
  },
  methods: {
    goToDashboard() {
      this.confirmOk = true;
      this.$refs.modal.close();
      this.$router.replace({ name: 'business.dashboard' });
    },
    onCloseModal() {
      if (!this.confirmOk) {
        this.$refs.modal.open();
      }
    },
  },
};
</script>
